import axios from 'axios'
import router from '@/router'
import {Loading, Message} from 'element-ui';

let loading = null
const http = axios.create({
  timeout: 1000 * 30,
  withCredentials: true,
  baseURL: process.env.API,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
  console.log('config',config)
  // if (config.url !== '/login') { //登录接口不需要accessToken
  //   config.headers.Authorization = getCookie('accessToken')
  // }
  loading = Loading.service({
    lock: false, // true时浏览器锁定禁止滚动  false 可以滚动
    background: 'transparent'
  });
  return config
}, error => {
  if (loading) loading.close();
  return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(response => {
  let data = {}
  if (response && response.data) {
    let status = Number(response.status)
    let code = Number(response.data.code)
    let msg = response.data.msg
    switch (status) {
      case 401:
        Message.error('身份过期，请重新登录!')
        goLogin()
        break
      case 200:
        data = response.data
        break
      default:
        Message.error((response.data && msg) || '网络连接出错!请稍后刷新重试!')
    }
  }
  if (loading) loading.close();
  return data
}, error => {
  if (loading) loading.close();
  Message.error('哎呀~ (ಥ﹏ಥ)网络又开小差了,请稍后刷新重试!')
  return Promise.reject(error)
})

//退出
function goLogin() {
    setTimeout( router.replace({name: 'login'}),1200)
}

export default http



// WEBPACK FOOTER //
// ./src/axios/index.js